const expiryThreshold = 5000;
export default class AuthenticationResponse {
    constructor(success, grant_type, props) {
        const { access_token, refresh_token, expires_in, issued_at, force_password_change, region, error, error_description } = props;

        const refresh_expires_in = refresh_token ? 60 * 60 : undefined; // 60 mins

        this.AccessToken = access_token;
        this.RefreshToken = refresh_token;
        this.IssuedAt = issued_at ? new Date(issued_at) : new Date();
        this.ExpiryDate = expires_in ? new Date(this.IssuedAt.getTime() + (expires_in * 1000)) : undefined;
        this.RefreshExpiryDate = refresh_expires_in ? new Date(this.IssuedAt.getTime() + (refresh_expires_in * 1000)) : undefined;
        this.ChangePassword = force_password_change ? (force_password_change !== 'none') : false;
        this.region = region;
        this.ErrorType = error;
        this.ErrorMessage = error_description;
        this.Success = success;
        this.GrantType = grant_type;
    }

    shouldTokenBeValid = (expiryDate, timeBeforeExpiry) => expiryDate.getTime() - Date.now() >= timeBeforeExpiry;

    checkTokenValidity = (token,tokenExpiryDate) => {
        return ( 
            token &&
            tokenExpiryDate && 
            this.Success &&
            this.shouldTokenBeValid(tokenExpiryDate,expiryThreshold)
        )
    }

    isValid = () => this.checkTokenValidity(this.AccessToken, this.ExpiryDate);

    isRefreshTokenValid = () => this.checkTokenValidity(this.RefreshToken, this.RefreshExpiryDate);

    needsRefresh = (randomTime) => {
        return (
            this.ExpiryDate &&  
            !this.shouldTokenBeValid(this.ExpiryDate, expiryThreshold + randomTime)
        );
    }
}
